// 话务数据

export default {
  state: {
    received_msg: null,
    lineState: false
  },
  mutations: {
    /** 接收服务器返回的消息体 */
    receiveMsg (state, msg) {
      state.received_msg = msg
    },
    /** 发送状态判断 */
    resetLineState (state, msg) {
      state.lineState = msg
    }
  }
}
